import React, { useContext } from "react";
import "../style.css";
import { CurrencyContext } from "./CurrencyContext";

const CurrencySelector = () => {
  // const [selectedCurrency, setSelectedCurrency] = useState("1035987"); // Default: USD

const {selectedCurrency , setSelectedCurrency} = useContext(CurrencyContext);

  // Handle currency change from dropdown
  const handleCurrencyChange = (event) => {
    const newCurrency = event.target.value;
    setSelectedCurrency(newCurrency);
    localStorage.setItem("selectedCurrency", newCurrency);

    if (window.OVExplore10) {
      window.OVExplore10.preferences.siteItemId = newCurrency;
      if (typeof window.initializeOdySearchForm === "function") {
        window.initializeOdySearchForm(window.OVExplore10);
        console.log("Search form reinitialized with new currency.");
      }
    }
  };

  // Load saved currency on first load
  // useEffect(() => {
  //   const savedCurrency = localStorage.getItem("selectedCurrency");
  //   if (savedCurrency) {
  //     setSelectedCurrency(savedCurrency);

  //     if (window.OVExplore10) {
  //       window.OVExplore10.preferences.siteItemId = savedCurrency;
  //       if (typeof window.initializeOdySearchForm === "function") {
  //         window.initializeOdySearchForm(window.OVExplore10);
  //         console.log("Search form reinitialized with saved currency.");
  //       }
  //     }
  //   }
  // }, [setSelectedCurrency]);

  return (
    <div className="navbar-dropdown">
      <select value={selectedCurrency} onChange={handleCurrencyChange}>
        <option value="1035987">USD</option>
        {/* <option value="1035988">SGD</option> */}
        <option value="1113842">INR</option>
      </select>
    </div>
  );
};

export default CurrencySelector;
